import { useContext, useState } from "react";
import { AuthContext } from "../context/authContext";
import client from "../utils/client";
import { useNavigate } from "react-router-dom";

const useDeposit = () => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const { token } = useContext(AuthContext);
  const navigate = useNavigate();

  const deposit = async (asset, network, txnId, amount) => {
    setLoading(true);
    setError(null);
    client({
      url: `/pool/deposit`,
      data: { asset, network, txnId, amount },
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (res.status === 200) {
          setSuccess(true);
          setLoading(false);
          navigate("/dashboard");
        }
      })
      .catch((err) => {
        console.log(err);
        setError(err.response.data.message);
        setLoading(false);
        setSuccess(false);
      });
  };
  return { deposit, loading, error, success };
};

export default useDeposit;
